"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _Image = _interopRequireDefault(require("../Image"));
var _Truncate = _interopRequireDefault(require("../Truncate"));
var _placeholderMock = _interopRequireDefault(require("./placeholder.mock.json"));
var _links = require("../_utils/links");
var _Text = _interopRequireDefault(require("../Text"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    itemTitle: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(2),
      color: theme.palette.secondary.main,
      wordBreak: 'break-word'
    },
    title: {
      marginBottom: '36px',
      marginTop: '0 !important'
    }
  };
});
var imageStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      '& img': {
        marginBottom: 0,
        maxWidth: '290px',
        width: '100%'
      }
    }
  };
});
var FeatureTilesEditConfig = {
  emptyLabel: 'Feature Tiles',
  isEmpty: function isEmpty(props) {
    if (props.tiles && props.tiles.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var Tile = function Tile(_ref) {
  var title = _ref.title,
    itemText = _ref.itemText,
    url = _ref.url,
    image = _ref.image;
  var classes = useStyles();
  var imageClasses = imageStyles();
  var linkProps = (0, _links.getTarget)(url);
  return __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, image ? __jsx("div", null, __jsx(_Image.default, (0, _extends2.default)({}, image, {
    size: "sm",
    classesInjected: imageClasses
  }))) : null, __jsx(_core.Link, (0, _extends2.default)({
    href: url,
    className: classes.itemTitle,
    color: "primary"
  }, linkProps, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), itemText ? __jsx(_Truncate.default, {
    divTag: true,
    lines: 5
  }, __jsx(_Text.default, itemText)) : null);
};
var FeatureTiles = function FeatureTiles(props) {
  var classes = useStyles();
  var heading = props.heading,
    ariaLabel = props.ariaLabel,
    anchorId = props.anchorId;
  var tiles = props.tiles;
  if (heading === null || heading === undefined) {
    // heading = placeholderContent.heading
  }
  if (tiles === null || tiles === undefined) {
    tiles = _placeholderMock.default.tiles;
  }
  return __jsx("div", {
    id: anchorId,
    className: (0, _clsx.default)('cmp-featuretiles', 'aem-ms-cmp', 'aem-ms-feature-tiles'),
    "aria-label": ariaLabel
  }, __jsx("h2", {
    className: classes.title,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), __jsx(_core.Grid, {
    container: true,
    spacing: 6
  }, tiles.map(function (props, index) {
    return __jsx(Tile, (0, _extends2.default)({}, props, {
      key: index
    }));
  })));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/featuretiles')(FeatureTiles, FeatureTilesEditConfig);
exports.default = _default;